import { Component } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { Router } from '@angular/router';
import { AccountService } from '@services/account.service';
@Component({
  selector: 'app-email-reset-password',
  templateUrl: './email-reset-password.component.html',
  styleUrls: ['./email-reset-password.component.css']
})
export class EmailResetPasswordComponent {
  emailResetPassword!: any;
  submitted: boolean = false;
  err!:any;
  get email(){return this.emailResetPassword.get('email'); }
  constructor(private router: Router,private resetLinkpass: AccountService){

  }
  ngOnInit(): void {
    this.emailResetPassword= new FormGroup({
      "email": new FormControl("", [Validators.required,Validators.email]),
    })
  }
  resendlink(){
    if (this.emailResetPassword.valid && this.email.value != null){
      this.submitted = true;
      this.resetLinkpass.sendLink(this.emailResetPassword.value).subscribe((result)=>{
        this.submitted = false;

        this.router.navigateByUrl('/resetpasslink')
      },
        (error)=>{
          this.submitted = false;
          this.err = error;
        }
      );
    } else{
      this.submitted = false;
      this.validateform(this.emailResetPassword)
    }
  }
  private validateform(form: FormGroup ){
    Object.keys(form.controls).forEach(field =>{
      const controls =  form.get(field);
      if(controls instanceof FormControl){
        controls.markAsDirty({onlySelf: true});

      }else if(controls instanceof FormGroup){
        this.validateform(controls)
      }
    })

  }
}
